<template>
    <div class="content">
        <left-bar activePathKey="message" ref="leftBar"></left-bar>
        <div style="width:1260px">
            <div class="title-bar">
                <span style="font-size: 20px;font-weight:600;">消息通知</span>
                <el-button type="text" style="padding:0;margin:0;" @click="clearUnread">
                    <div style="display:flex;align-items:center;">
                        <el-image :src="require('@/assets/images/icon/clear.png')"
                            style="width:24px;height:24px"></el-image>
                        <div style="color:#4E4E4E;font-size:16px;line-height:24px">全部已读</div>
                    </div>
                </el-button>
            </div>
            <div class="select-bar">
                <div class="select-bar-item">
                    <div style="margin-right:10px">通知类型：</div>
                    <el-button v-for="(item, index) in noticeTypeList" :key="index" @click="changeNoticeType(item.value)"
                        :class="selectedNoticeType === item.value ? 'active' : 'normal'">
                        {{ item.name }}
                    </el-button>
                </div>
                <div class="select-bar-item">
                    <div style="margin-right:10px">消息时间：</div>
                    <el-button v-for="(item, index) in dayTypeList" :key="index" @click="changeDayType(item.value)"
                        :class="selectedDayType === item.value ? 'active' : 'normal'">
                        {{ item.name }}
                    </el-button>
                </div>
            </div>
            <div style="min-height:400px">
                <el-table :data="msgList" :show-header="false" v-loading="loadingStatus">
                    <el-table-column>
                        <template slot-scope="{row}">
                            <div class="msg-item">
                                <div style="flex:1;">
                                    <div style="display:flex;align-items:center;margin-bottom:20px;">
                                        <div class="msg-item-tips" :style="{ background: row.beRead ? '#fff' : '' }"> </div>
                                        <el-image :src="require('@/assets/images/icon/notice.png')"
                                            style="width:24px;height:24px"></el-image>
                                        <div class="msg-item-title text-line1"> {{ row.title || "-" }}</div>
                                    </div>
                                    <div class="msg-item-content text-line1" style="margin-left:50px">{{ row.content || "-"
                                    }} </div>
                                </div>
                                <div class="msg-item-content">{{ getDisplayTime(row.createDate) }}</div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align:right;margin-top:40px;margin-bottom:100px">
                    <el-pagination :current-page="current" :page-sizes="[10, 20]" :page-size="size" :total="total"
                        layout="total, sizes, prev, pager, next, jumper" @size-change="handleChangeSize"
                        @current-change="handleChangeCurrent">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import leftBar from "../components/left-bar/left-bar.vue"
import { getMsgNoticePage, clearUnread } from "@/api/personalCenter"
import { mapState } from "vuex"
import { geTime } from '@/utils/public'

export default {
    components: {
        leftBar
    },
    data() {
        return {
            size: 10,
            current: 1,
            msgList: [],
            noticeTypeList: [{ name: "全部", value: "all" }, { name: "系统通知", value: "announcement" },],
            dayTypeList: [{ name: "全部", value: 0 }, { name: "近7天", value: 7 }, { name: "近30天", value: 30 }],

            selectedNoticeType: "all",
            selectedDayType: 0,
            total: 0,
            loadingStatus: false,
        }
    },
    computed: {
        ...mapState("account", ["token", "userInfos"])
    },
    mounted() {
        document.title = "邦建通-个人中心";
        if (!this.token) {
            this.$router.replace("/")
        }
        this.getMsgList()
    },
    methods: {
        changeNoticeType(type) {
            if (type === this.selectedNoticeType) return
            this.selectedNoticeType = type
            this.current = 1
            this.getMsgList()
        },
        changeDayType(type) {
            if (type === this.selectedDayType) return
            this.selectedDayType = type
            this.current = 1
            this.getMsgList()
        },

        async clearUnread() {
            try {
                await clearUnread({
                    tarCreditCode: this.userInfos?.creditCode,
                })
                this.$message.success("消息已读成功")
                this.msgList.forEach(item => item.beRead = 1)
                this.$refs.leftBar.clearUnread()
            } catch (err) {

            }
        },

        async getMsgList() {
            try {
                console.log("userInfouserInfo", this.userInfos)
                this.loadingStatus = true

                let params = {
                    size: this.size,
                    current: this.current,
                    tarCreditCode: this.userInfos?.creditCode,
                }

                if (this.selectedNoticeType !== "all") {
                    params.type = this.selectedNoticeType
                }

                if (this.selectedDayType !== 0) {
                    let endTime = new Date().getTime()
                    let startTime = endTime - 24 * 60 * 60 * 1000 * this.selectedDayType
                    params.endDate = geTime(endTime, "yyyy-MM-dd HH:mm:ss")
                    params.startDate = geTime(startTime, "yyyy-MM-dd") + ' 00:00:00'
                }
                let { data } = await getMsgNoticePage(params)
                this.total = data.total
                this.msgList = data.records
                this.loadingStatus = false
            } catch (err) {
                this.loadingStatus = false
            }
        },

        handleChangeSize(size) {
            this.size = size
            this.getMsgList()
        },
        handleChangeCurrent(current) {
            this.current = current
            this.getMsgList()
        },

        getDisplayTime(time) {
            if (!time) return "-"
            let timeArr = time.split(" ")
            return timeArr[0] || "-"
        }
    }
}

</script>

<style scoped>
.content {
    background: #F8F9FB;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 20px;
    font-family: Source Han Sans CN-Regular;
    color: #212121;
}

.title-bar {
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.select-bar {
    padding: 20px;
    border: 1px solid #DCE5F2;
    font-size: 16px;
    color: #4E4E4E;
    background: #fff;
    text-align: left;
    margin-bottom: 20px;
}

.select-bar-item {
    display: flex;
    align-items: center;
}

.select-bar-item+.select-bar-item {
    margin-top: 20px;
}

.select-bar-item>.el-button {
    padding: 8px;
    margin-right: 22px;
    font-size: 16px;
}

.select-bar-item>.active {
    color: #007EF2;
    border: none;
    background: #EDF4FF;
}

.select-bar-item>.normal {
    color: #4e4e4e;
    border: none;
    background: #fff;
}

.msg-item {
    display: flex;
    align-items: center;
    padding-right: 30px;
}

.msg-item-tips {
    width: 6px;
    height: 6px;
    background: #F81E1E;
    border-radius: 6px;
    margin-right: 10px;
    flex-shrink: 0;
}

.msg-item-title {
    font-size: 20px;
    font-weight: 600;
    color: #21262D;
}

.msg-item-content {
    font-size: 14px;
    color: #888;
    line-height: 14px;
    flex-shrink: 0;
    margin-left: 50px;
}

.text-line1 {
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: pre-wrap;
}
</style>